import { RootState } from 'src/store';

export const getEntityListParams = (state: RootState) =>
  state?.detailsModel?.tableParams || {};

export const getDetails = (state: RootState, entityId: string) =>
  entityId ? state?.detailsModel?.details[entityId] : {};

export const getCurrentEntityId = (state: RootState) =>
  state?.detailsModel?.currentEntityId;
